import { Component, inject, HostListener, OnInit, ViewChild } from '@angular/core'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { ConfirmationService } from 'primeng/api'

// Wrapper enabling CodeEditorComponent to be called with primeNG DialogService
// Allows to have a clean CodeEditorCOmponent
@Component({
  selector: 'jml-lib-code-wrapper-dlg-srvc',
  templateUrl: './code-wrapper-dlg-srvc.component.html',
  styleUrls: ['./code-wrapper-dlg-srvc.component.scss']
})
export class CodeWrapperDlgSrvcComponent implements OnInit {
  syntax: string
  code: string
  saveButtonLabel: string
  saveIcon: string
  readonly: boolean
  isDirty = false

  @ViewChild('codeEditor', { static: false }) codeEditor

  private ref = inject(DynamicDialogRef)
  private config = inject(DynamicDialogConfig)
  private confirmationService = inject(ConfirmationService)

  ngOnInit() {
    this.syntax = this.config.data['syntax']
    this.code = this.config.data['code']
    this.saveButtonLabel = this.config.data['saveButtonLabel']
    this.saveIcon = 'pi pi-save'
    this.readonly = this.config?.data?.['readOnly'] ?? false
    this.overrideDialogClose()
  }

  private overrideDialogClose() {
    // store original close method
    const originalClose = this.ref.close.bind(this.ref)

    // override prime-NGs close method
    this.ref.close = (result?: any) => {
      if (this.isDirty && !this.readonly) {
        this.confirmClose(() => originalClose(result))
      } else {
        originalClose(result)
      }
    }
  }

  private confirmClose(closeCallback: () => void) {
    this.confirmationService.confirm({
      message: 'Möchten Sie den Dialog ohne Speichern verlassen?',
      header: 'Ungespeicherte Änderungen',
      key: 'global',
      accept: closeCallback,
      reject: () => {
        this.codeEditor.focus()
      }
    })
  }

  onDirtyChange(dirty: boolean) {
    this.isDirty = dirty
  }

  save(editedCode: string) {
    // reset dirty state before closing
    this.isDirty = false
    this.ref.close(editedCode)
  }
}
